/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useParams, useLocation, useSearchParams } from "react-router-dom";
import axios from "axios";
import { Ring } from "./Ring";
import { useTranslation } from 'react-i18next';

import "./UnsubscribePage.scss";
import loading from "./loading-inverse.gif";

export function UnsubscribePage(props) {
  const { t, i18n } = useTranslation();
  const { customer, notificationId, token } = useParams();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [customerInfo, setCustomerInfo] = useState(false);
  const [sent, setSent] = useState(false);
  const [notificationInfo, setNotificationInfo] = useState(null);
  const [error, setError] = useState(null);

  // Detectar qual tipo de unsubscribe
  const isTokenBased = location.pathname.includes('/token/');
  const identifier = isTokenBased ? token : notificationId;
  
  // Pegar source da query string (default: review)
  // Valores: 'review' ou 'nps'
  const source = searchParams.get('source') || 'review';

  const getData = async () => {
    setIsLoading(true);
    setError(null);

    try {
      var customerData = await axios.get(
        `${process.env.REACT_APP_API_URL}/${customer}/info`
      );

      setCustomerInfo(customerData.data);

      // Endpoint diferente baseado no tipo
      let endpoint;
      if (isTokenBased) {
        // Token: não precisa de source (thank you)
        endpoint = `${process.env.REACT_APP_API_URL}/${customer}/unsubscribe/token/${identifier}`;
      } else {
        // NotificationId: adicionar query string do source
        endpoint = `${process.env.REACT_APP_API_URL}/${customer}/notifications/subscription/${identifier}?source=${source}`;
      }

      var notification = await axios.get(endpoint);

      setNotificationInfo(notification.data);
    } catch (err) {
      console.error('Erro ao buscar informações de unsubscribe:', err);
      
      let errorMessage = t('unsubscribe_error_default');
      
      if (err.response?.status === 404) {
        errorMessage = t('unsubscribe_error_not_found');
      } else if (err.response?.status === 410) {
        errorMessage = t('unsubscribe_error_expired');
      } else if (err.response?.data?.message) {
        errorMessage = err.response.data.message;
      }
      
      setError(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  const sendOptOut = async () => {
    setIsSubmitting(true);
    
    try {
      let endpoint;
      if (isTokenBased) {
        // Token: não precisa de source (thank you)
        endpoint = `${process.env.REACT_APP_API_URL}/${customer}/unsubscribe/token/${identifier}`;
      } else {
        // NotificationId: adicionar query string do source
        endpoint = `${process.env.REACT_APP_API_URL}/${customer}/notifications/optOut/${identifier}?source=${source}`;
      }
      
      await axios.post(endpoint);
      setSent(true);
    } catch (err) {
      console.error('Erro ao processar opt-out:', err);
      
      let errorMessage = t('unsubscribe_error_submit');
      
      if (err.response?.data?.message) {
        errorMessage = err.response.data.message;
      }
      
      alert(errorMessage);
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    getData();
  }, [customer, notificationId, token]);

    useEffect(() => {
      if (customerInfo?.settings?.locale) {
        i18n.changeLanguage(customerInfo.settings.locale)
      }
    }, [customerInfo])

  // Loading state
  if (isLoading) {
    return (
      <div className="unsubscribe-page">
        <div className="loading-container">
          <Ring />
        </div>
      </div>
    );
  }

  // Error state
  if (error) {
    return (
      <div className="unsubscribe-page error">
        <div className="logo">
          {customerInfo?.logo && (
            <img src={customerInfo.logo} alt={t('alt.customer_logo', { name: customerInfo.name })} />
          )}
        </div>
        <div className="error-container">
          <div className="error-icon">
            <i className="bi bi-exclamation-circle"></i>
          </div>
          <h2>{t('unsubscribe_error_title')}</h2>
          <p>{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="unsubscribe-page">
      <div className="logo">
        <img src={customerInfo.logo} alt={t('alt.customer_logo', { name: customerInfo.name })} />
      </div>
      <h1>{t('unsubscribe_title', { storeName: customerInfo.name })}</h1>

      {notificationInfo && (
        <>
          {!sent ? (
            <div className="unsubscribe-form">
              {notificationInfo.email && (
                <p>{t('email_label', { email: notificationInfo.email })}</p>
              )}
              {notificationInfo.phone && (
                <p>{t('unsubscribe_phone_label', { phone: notificationInfo.phone })}</p>
              )}

              <p>
                {t('unsubscribe_prompt', { method: notificationInfo.email ? t('email') : t('whatsapp') })}
              </p>

              <button
                className="btn-unsubscribe"
                onClick={() => {
                  sendOptOut();
                }}
              >
                {t('unsubscribe_button', { method: notificationInfo.email ? t('emails') : t('messages') })}
                {isSubmitting && <img alt={t('alt.loading')} src={loading} />}
              </button>
            </div>
          ) : (
            <div className="success-message">
              {t('unsubscribe_success')}
            </div>
          )}
        </>
      )}
    </div>
  );
}